import { PRESIDING_JUDGE_POSITION } from "score-common";

// Card #3075 - the pure rules behind the ride-level No Show (#1992) and
// Excused (#2064) gavel actions, pulled out of ScoringForm.jsx so they can be
// tested by calling them directly instead of mounting the whole form. The
// server enforces the same C-only gate independently; this only decides what
// the UI offers.

/** Only the presiding judge (position C) is offered the ride-level rulings. */
export function canMarkRideRuling(judgePosition) {
  return judgePosition === PRESIDING_JUDGE_POSITION;
}

/**
 * What the alert banner should show for a ride-level ruling record, or null
 * when there is nothing to show (no record, or an inactive one).
 *
 * `who` never carries the raw Cognito sub the server stamps on `by`: it is
 * the judge's resolved name for `byPosition` (Class.judgeAssignments), a bare
 * position fallback when the class has no name for that seat, or "unknown"
 * (an admin who wasn't seated at C). `canUndo` is C-only, matching the
 * server's gate on the DELETE.
 */
export function resolveRulingAlert(record, klass, judgePosition) {
  if (!record?.active) return null;
  let who;
  if (record.byPosition) {
    const name = klass?.judgeAssignments?.[record.byPosition]?.[0];
    // `!= null`, not truthiness: the original was `?? fallback`, so an empty-
    // string name stays a name (no behaviour change from the extraction).
    who = name != null
      ? { kind: "name", name }
      : { kind: "position", position: record.byPosition };
  } else {
    who = { kind: "unknown" };
  }
  return { canUndo: canMarkRideRuling(judgePosition), who, at: record.at };
}
